import React, {useEffect, useState} from "react";
import {IAgSwipeProps} from "./AgSwipe.props";
import {CustomeSwipeList} from "./AgSwipe.styled";

const AgSwipe: React.FC<IAgSwipeProps> = ({
  childElement,
  TrailItems,
  onClickElement,
  data,
  currentOpenIndex,
  elementId,
  setOpenIndex,
  TrailItemsWidth,
  onCloseAllTrailItems,
  isCloseAllTrailItems,
  isClickAddInquiry,
  isClickExportExcel,
  isClickFilterOnMobile,
  onCloseTrailItem,
  ...props
}) => {
  const [left, setLeft] = useState(0);
  const [touchXStart, setTouchXStart] = React.useState(0);
  const [touchYStart, setTouchYStart] = React.useState(0);
  const [clickStart, setClickStart] = React.useState(0);
  const [isHideTrail, setIsHideTrail] = React.useState(true);

  const swipeLengthIndex = 40;
  const touchYMinIndex = 1;

  function handleTouchStart(e: any) {
    setTouchXStart(e.targetTouches[0].clientX);
    setTouchYStart(e.targetTouches[0].clientY);
  }
  function handleTouchEnd(e: any) {
    if (
      touchXStart - e.changedTouches[0].clientX === 0 &&
      touchYStart - e.changedTouches[0].clientY === 0
    ) {
      onClickElement?.(data);
      onCloseAllTrailItems(true);
      setIsHideTrail(true);
    } else {
      if (touchXStart - e.changedTouches[0].clientX > swipeLengthIndex) {
        setLeft(TrailItemsWidth * -1);
        setIsHideTrail(false);
      } else {
        if (Math.abs(touchYStart - e.changedTouches[0].clientY) > touchYMinIndex) {
          onCloseAllTrailItems(true);
          setIsHideTrail(true);
        }
        if (touchXStart - e.changedTouches[0].clientX <= swipeLengthIndex) {
          setLeft(0);
        } else {
          if (Math.abs(touchYStart - e.changedTouches[0].clientY) > touchYMinIndex) {
            onCloseAllTrailItems(true);
            setIsHideTrail(true);
          }
        }
      }
    }
    setTouchXStart(0);
    setTouchYStart(0);
  }
  function handleOnMouseDown(e: any) {
    setClickStart(e.clientX);
  }

  function handleOnMouseUp(e: any) {
    if (clickStart - e.clientX === 0) {
      onClickElement?.(data);
      onCloseAllTrailItems(true);
      setIsHideTrail(true);
    } else {
      if (clickStart - e.clientX > swipeLengthIndex) {
        setLeft(TrailItemsWidth * -1);
        setIsHideTrail(false);
      }

      if (clickStart - e.clientX <= swipeLengthIndex) {
        setLeft(0);
        setIsHideTrail(true);
      }
    }
  }

  useEffect(() => {
    if (left === 0) {
      setOpenIndex(null);
    } else {
      setOpenIndex(elementId);
    }
  }, [left, setOpenIndex, elementId]);

  useEffect(() => {
    if (
      (currentOpenIndex !== null && currentOpenIndex !== elementId) ||
      isClickAddInquiry ||
      isClickExportExcel ||
      isCloseAllTrailItems ||
      isClickFilterOnMobile
    ) {
      setLeft(0);
      onCloseTrailItem();
    }
    onCloseAllTrailItems(false);
  }, [
    currentOpenIndex,
    elementId,
    isClickAddInquiry,
    isClickExportExcel,
    isClickFilterOnMobile,
    isCloseAllTrailItems,
    onCloseTrailItem,
    onCloseAllTrailItems,
  ]);

  return (
    <CustomeSwipeList>
      <div className="swipe-list">
        <div className={`box-action flex`}>
          {isHideTrail && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 1)",
                zIndex: 1,
              }}
            ></div>
          )}
          <div
            style={{
              visibility: isHideTrail ? "hidden" : "visible",
            }}
          >
            {TrailItems}
          </div>
        </div>
        <div>
          <div
            className="item"
            style={{transform: `translate3d(${left}px, 0, 0)`}}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onMouseDown={handleOnMouseDown}
            onMouseUp={handleOnMouseUp}
          >
            {childElement}
          </div>
        </div>
      </div>
    </CustomeSwipeList>
  );
};

export default AgSwipe;
